var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.30895V0.689927C0 0.363534 0.333047 0 0.555079 0H23.2973C23.667 0 24 0.363534 24 0.689927V4.98255C22.7433 5.09173 21.5966 5.45526 20.5608 6H0.555079C0.333047 6 0 5.63647 0 5.30895ZM2 4H4V2H2V4ZM5 4H7V2H5V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.3101V9.69105C0 9.36353 0.333047 9 0.555079 9H23.2973C23.667 9 24 9.36353 24 9.69105V13.9826C22.7433 14.0917 21.5966 14.4553 20.5608 15H0.555079C0.333047 15 0 14.6365 0 14.3101ZM2 13H4V11H2V13ZM5 13H7V11H5V13Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.6911C0 18.3635 0.333047 18 0.555079 18H23.2973C23.667 18 24 18.3635 24 18.6911V22.9826C24 23.6275 23.8318 24 22.5599 24H0.555079C0.333047 24 0 23.6376 0 23.3101V18.6911ZM2 22H4V20H2V22ZM5 22H7V20H5V22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServers);
export default __webpack_public_path__ + "static/media/servers.2f01bd0a5fd010681ddc29d8e20c42df.svg";
export { ForwardRef as ReactComponent };